fg.directive('fgEditCanvasField', function() {

  return {
    templateUrl: 'angular-form-gen/edit/canvas/field/field.ng.html'
  };

});